import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const Footer = () => {
  return (
    <motion.footer
      className="bg-gray-950 text-white pt-16 pb-8 px-6"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={fadeInUp}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 text-sm">
        {/* Company Info */}
        <div>
          <h4 className="text-3xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
            MyMarketing<span className="text-green-500">Buddy</span>
          </h4>
          <p className="text-gray-400 leading-relaxed">
            Automate WhatsApp marketing, engage customers, and grow your business-all in one place.
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-4 text-blue-400">Contact</h4>
          <div className="space-y-2 text-sm text-gray-300">
            <div className="flex items-center gap-2">
              <Mail size={16} />
              <a href="mailto:info@mymarketingbuddy.com" className="hover:text-blue-300 transition">
                info@mymarketingbuddy.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={16} />
              <a href="tel:+919558213897" className="hover:text-blue-300 transition">
                +91 95582 13897
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin size={16} />
              <span>India</span>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4 text-blue-400">Follow Us</h4>
          <p className="text-gray-500 text-sm mb-2 italic">(Coming soon)</p>
          <div className="flex gap-4 text-gray-500 opacity-60">
            <span className="flex items-center gap-2 cursor-not-allowed">
              <Linkedin size={18} /> LinkedIn
            </span>
            <span className="flex items-center gap-2 cursor-not-allowed">
              <Twitter size={18} /> Twitter
            </span>
            <span className="flex items-center gap-2 cursor-not-allowed">
              <Instagram size={18} /> Instagram
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800 mt-12 pt-4 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} MyMarketingBuddy. All rights reserved.
      </div>
    </motion.footer>
  );
};

export default Footer;
